<header class="home-header">
  <div class="header-container">

    <!-- Logo -->
    <a class="navbar-brand d-flex align-items-center" href="/">
      <div class="logo-wrapper-nav">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280 70" class="ksna-logo" width="100%" height="100%">
          <!-- Icon representing Home & Electronics -->
          <g transform="translate(10, 10)">
            <!-- House Outline -->
            <path d="M25 0 L50 20 L50 50 L0 50 L0 20 Z" fill="none" stroke="#ffffff" stroke-width="4" stroke-linejoin="round"/>
            <!-- Lightning Bolt (Appliances/Electronics) -->
            <path d="M28 8 L14 28 L28 28 L20 44" fill="none" stroke="#0d6efd" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </g>

          <!-- Brand Text -->
          <text x="75" y="36" font-family="system-ui, -apple-system, sans-serif" font-size="26" font-weight="800" fill="#ffffff">KSNA</text>
          <text x="76" y="54" font-family="system-ui, -apple-system, sans-serif" font-size="13" font-weight="600" fill="#ffffff" letter-spacing="3">MARKETINGS</text>
        </svg>
      </div>
    </a>

    <!-- Nav Links -->
    <nav class="nav-links">
      <a routerLink="/products" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}" class="nav-link">Products</a>
      <!--<a href="javascript:void(0)" class="nav-link">On Sale</a>
      <a href="javascript:void(0)" class="nav-link">Contact Us</a>-->
    </nav>

    <!-- Right Actions -->
    <div class="header-actions">
      @if (!isLoggedIn) {
        <a routerLink="/auth/login" class="action-link login-link">
          <i class="bi bi-person-circle"></i>
          <span>Log In</span>
        </a>
      } @else {
        <div class="user-profile-wrapper">
          <div class="action-link user-info-link">
            <i class="bi bi-person-check-fill"></i>
            <span class="user-name">{{ userName }}</span>
            <i class="bi bi-chevron-down ms-1" style="font-size: 10px; margin-top: 2px;"></i>
          </div>

          <div class="profile-dropdown">
            <a routerLink="/my-orders" class="profile-dropdown-item">
              <i class="bi bi-box-seam"></i> My Orders
            </a>
            <div class="dropdown-divider"></div>
            <button class="profile-dropdown-item text-danger" (click)="logout()">
              <i class="bi bi-box-arrow-right"></i> Logout
            </button>
          </div>
        </div>
      }
      <a routerLink="/cart" class="action-link cart-link" routerLinkActive="active-link">
        <i class="bi bi-cart3"></i>
        <span class="cart-badge">{{ (cartCount$ | async) || 0 }}</span>
      </a>
    </div>

    <!-- Mobile Menu Toggle -->
    <button class="mobile-menu-btn" aria-label="Menu" (click)="toggleMobileMenu()">
      <i class="bi bi-list"></i>
    </button>

  </div>

  <!-- Categories Sub-navbar -->
  <div class="categories-menu-bar">
    <div class="categories-menu-container">
      @for (category of categories(); track category.categoryId) {
        <div class="category-menu-wrapper">
          <a [routerLink]="['/products', category.categoryId]" routerLinkActive="active-category" class="category-menu-item">
            {{ category.categoryName }}
            @if (category.subCategories && category.subCategories.length > 0) {
              <i class="bi bi-chevron-down dropdown-arrow"></i>
            }
          </a>
          @if (category.subCategories && category.subCategories.length > 0) {
            <div class="subcategory-dropdown">
              @for (sub of category.subCategories; track sub.subCategoryId) {
                <a [routerLink]="['/products', category.categoryId]" [queryParams]="{ subCategoryId: sub.subCategoryId }" routerLinkActive="active-subcategory" class="subcategory-item">
                  {{ sub.subCategoryName }}
                </a>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!-- Mobile Off-Canvas Sidebar -->
  <div class="mobile-sidebar-overlay" [class.open]="isMobileMenuOpen()" (click)="closeMobileMenu()"></div>
  <div class="mobile-sidebar" [class.open]="isMobileMenuOpen()">
    <div class="mobile-sidebar-header">
      <a class="logo" routerLink="/" (click)="closeMobileMenu()">
        <img src="assets/logo/ksna-logo-4.png" alt="KSNA Home Appliances" class="logo-img"/>
      </a>
      <button class="close-sidebar-btn" (click)="closeMobileMenu()">
        <i class="bi bi-x"></i>
      </button>
    </div>

    <div class="mobile-sidebar-content">
      <!-- Mobile User Profile -->
      <div class="mobile-user-section">
        @if (!isLoggedIn) {
          <a routerLink="/auth/login" class="mobile-action-link" (click)="closeMobileMenu()">
            <i class="bi bi-person-circle"></i>
            <span>Log In</span>
          </a>
        } @else {
          <div class="mobile-user-info">
            <i class="bi bi-person-check-fill"></i>
            <span class="user-name">{{ userName }}</span>
          </div>
          <a routerLink="/my-orders" class="mobile-action-link" (click)="closeMobileMenu()">
            <i class="bi bi-box-seam"></i> My Orders
          </a>
          <button class="mobile-action-link text-danger" (click)="logout(); closeMobileMenu()">
            <i class="bi bi-box-arrow-right"></i> Logout
          </button>
        }
      </div>

      <div class="mobile-divider"></div>

      <!-- Mobile Categories -->
      <div class="mobile-categories">
        <h4 class="mobile-section-title">CATEGORIES</h4>
        @for (category of categories(); track category.categoryId) {
          <div class="mobile-category-item">
            <div class="mobile-cat-header" (click)="toggleMobileCategory(category.categoryId, $event)">
              <a [routerLink]="['/products', category.categoryId]" routerLinkActive="active" (click)="closeMobileMenu()" class="mobile-cat-link">
                {{ category.categoryName }}
              </a>
              @if (category.subCategories && category.subCategories.length > 0) {
                <i class="bi bi-chevron-down ms-auto" [class.rotated]="expandedCategoryId() === category.categoryId"></i>
              }
            </div>

            @if (category.subCategories && category.subCategories.length > 0 && expandedCategoryId() === category.categoryId) {
              <div class="mobile-subcategories">
                @for (sub of category.subCategories; track sub.subCategoryId) {
                  <a [routerLink]="['/products', category.categoryId]" [queryParams]="{ subCategoryId: sub.subCategoryId }" routerLinkActive="active" (click)="closeMobileMenu()" class="mobile-subcat-link">
                    {{ sub.subCategoryName }}
                  </a>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</header>
